import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const AUTH_TOKEN_KEY = "anartizen_auth_token";
export const ADMIN_TOKEN_KEY = "anartizen_admin_token";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token (fallback for cross-site/third-party-cookie blocking).
// For admin URLs, prefer the admin token; fall back to the member token.
api.interceptors.request.use((config) => {
  const isAdminCall = (config.url || "").includes("/admin");
  const adminToken = localStorage.getItem(ADMIN_TOKEN_KEY);
  const memberToken = localStorage.getItem(AUTH_TOKEN_KEY);
  const token = isAdminCall ? (adminToken || memberToken) : memberToken;
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function setAuthToken(token) {
  if (token) localStorage.setItem(AUTH_TOKEN_KEY, token);
  else localStorage.removeItem(AUTH_TOKEN_KEY);
}

export function setAdminToken(token) {
  if (token) localStorage.setItem(ADMIN_TOKEN_KEY, token);
  else localStorage.removeItem(ADMIN_TOKEN_KEY);
}
